namespace Areas.Favorite {
    "use strict";

    export function goToFavorite(e: any) {
        const grid = $("#FavoriteGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].urlAddress;
            location.href = id;
        }
    }

}